module.exports = __webpack_public_path__ + "static/listening-image-f6ab66921e332ca2473876d8021b3d75.png";